import { INSTANCE_GRTD_READ_META } from 'client/redux/grtd/constants';
import * as actionCreators from 'client/redux/grtd/actionCreators';

export const instanceGrtdReadMeta = id => dispatch => {
  return dispatch(actionCreators.instanceGrtdReadMeta(INSTANCE_GRTD_READ_META, id));
};
